<div class="delivery-contact-request-view-part">
	<common-contact-request-grid [pageService]="pageService" [data]="contactRequests()"></common-contact-request-grid>
</div>